import Http from './http';
import config from '../config';

class HttpV2 extends Http {
  static getUrl(url) {
    return `${config.url}/v2${url}`;
  }
}

export default HttpV2;

